{
  "eyebrow": "Create your account",
  "title": "A few details about your company.",
  "sub": "You'll be the primary administrator. You can invite more admins after setup.",
  "company": "Company",
  "companyName": "Company name",
  "companyVat": "VAT number",
  "companyVatBssHint": "Required for Belgian Social Security (DIMONA) reporting.",
  "companyCountry": "Country",
  "companySector": "Industry",
  "companySectorPlaceholder": "Choose your industry",
  "sectors": {
    "construction": "Construction services",
    "cleaning": "Cleaning services",
    "business": "Business services",
    "horticulture": "Horticulture services",
    "other": "Other services"
  },
  "admin": "Primary administrator",
  "adminFirst": "First name",
  "adminLast": "Last name",
  "adminEmail": "Work email",
  "adminPhone": "Phone",
  "adminPw": "Password",
  "adminPwHint": "At least 10 characters, one number.",
  "adminPwShow": "Show password",
  "adminPwHide": "Hide password",
  "terms": {
    "pre": "I agree to the",
    "t": "Terms of Service",
    "and": "and",
    "p": "Privacy Policy"
  },
  "cta": "Create account & continue",
  "errors": {
    "required": "Required",
    "tooShort": "Too short",
    "invalidEmail": "Enter a valid email",
    "invalidVat": "Enter a valid VAT number",
    "invalidBelgianVat": "Enter a valid Belgian VAT number (e.g. BE0123456789).",
    "invalidPhone": "Enter a valid phone number",
    "passwordWeak": "At least 12 characters with one number",
    "termsRequired": "You must accept the terms",
    "emailExists": "This email is already in use",
    "vatRequiredForBss": "VAT is required for Belgian Social Security",
    "network": "Network or server error. Try again.",
    "throttled": "Too many attempts. Try again in {{minutes}} min."
  },
  "verify": {
    "awaitingTitle": "Check your inbox",
    "awaitingSub": "We sent a verification link to {{email}}. Click it to activate your account and start your free trial.",
    "awaitingSubNoEmail": "We sent you a verification link. Click it to activate your account and start your free trial.",
    "resend": "Resend email",
    "resendCooldown": "Resend in {{seconds}}s",
    "verifyingTitle": "Verifying…",
    "successTitle": "Your 30-day free trial has started!",
    "successSub": "No credit card required. Sign in to your dashboard to start using Done-it.",
    "errorTitle": "We couldn't verify that link",
    "errorSub": "The link may have expired. Start again from your account details.",
    "errorCta": "Back to account",
    "interstitial": "Email verification",
    "subscribedTitle": "Your account is ready",
    "subscribedSub": "You've already completed payment. Sign in to your dashboard to start using Done-it.",
    "subscribedCta": "Sign in to dashboard",
    "successCta": "Open dashboard",
    "successNote": "You'll get a few helpful emails during your trial, and a link to subscribe near the end.",
    "awaitingSubFree": "We sent a verification link to {{email}}. Click it to activate your free account — Time Zero is free forever, no credit card.",
    "awaitingSubFreeNoEmail": "We sent you a verification link. Click it to activate your free account — Time Zero is free forever, no credit card.",
    "successTitleFree": "Your free account is ready!",
    "successNoteFree": "Time Zero is free forever within its limits. Upgrade any time for unlimited use."
  }
}
